export interface RentToBuyCatalogContent {
  presentationTitle: string
  presentationDescription: string
  savingsTitle: string
  savingsDescription: string
  freedomTitle: string
  freedomDescription: string
  presentationNote: string
  discoverMoreLabel: string
  resultsSuffix: string
  priceLabel: string
  calculateLabel: string
  loadMoreLabel: string
}

export const defaultRentToBuyCatalogContent: RentToBuyCatalogContent = {
  presentationTitle: '🚗🚐 Il Rent to Buy su misura per la tua azienda!',
  presentationDescription: 'Scegli il tuo veicolo a un prezzo imbattibile e costruisci il tuo Rent to Buy su misura, personalizzando rata, acconto, cauzione e durata fino a 48 mesi.',
  savingsTitle: 'Il tuo salvadanaio:',
  savingsDescription: 'recuperi il 100% dei canoni versati, detraendoli dal prezzo di acquisto del veicolo, oppure trasformi il valore accumulato in un guadagno cedendo il contratto Rent to Buy a terzi a titolo oneroso (a tuo favore).',
  freedomTitle: 'Massima libertà:',
  freedomDescription: 'acquisti quando vuoi, senza penali, tu o chi vuoi tu.',
  presentationNote: 'Così il vantaggio economico è immediato: i canoni versati diventano valore utilizzabile per acquistare il veicolo oppure valorizzabile attraverso la cessione del contratto.',
  discoverMoreLabel: 'Scopri di più',
  resultsSuffix: 'veicoli disponibili',
  priceLabel: 'Prezzo di vendita',
  calculateLabel: 'Calcola il tuo Rent To Buy',
  loadMoreLabel: 'Mostra altri veicoli',
}

export function resolveRentToBuyCatalogContent(data?: object | null): RentToBuyCatalogContent {
  if (!data) return { ...defaultRentToBuyCatalogContent }
  const record = data as Record<string, unknown>
  return Object.fromEntries(
    Object.entries(defaultRentToBuyCatalogContent).map(([key, fallback]) => [
      key,
      typeof record[key] === 'string' && record[key].trim() ? record[key].trim() : fallback,
    ]),
  ) as unknown as RentToBuyCatalogContent
}
